import { useCallback, useEffect, useRef, useState } from "react"

import { toast } from "sonner"

import { deleteConversation, getConversations } from "@/lib/api"
import type { Conversation } from "@/types/api"

export function useConversations() {
  const [conversations, setConversations] = useState<Conversation[]>([])
  const [loading, setLoading] = useState(true)
  const mounted = useRef(true)

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  const refresh = useCallback(async () => {
    try {
      const list = await getConversations()
      if (mounted.current) setConversations(list)
    } catch {
      // history is unavailable without the conversation store — sidebar stays empty
    } finally {
      if (mounted.current) setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refresh()
  }, [refresh])

  const remove = useCallback(
    async (id: string) => {
      try {
        await deleteConversation(id)
      } catch {
        toast.error("Conversation could not be deleted. Please try again.")
        return
      }
      await refresh()
    },
    [refresh],
  )

  return { conversations, loading, refresh, remove }
}
